import angular from 'angular'
import directive from './picklist.directive'
import PicklistController from './picklist.controller'
import picklistItem from './picklist-dnd'
import modelAsPicklistHuman from './model-as-picklist-human'

export default angular
  .module('ellipsis.picklist', [])
  .directive('picklistDnd', picklistItem)
  .directive('picklist', directive)
  .controller('PicklistController', PicklistController)
  .directive('modelAsPicklistHuman', modelAsPicklistHuman)
